// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","theme--default":"theme--default","theme--dark":"theme--dark","app":"TxLpfliF0so4faRu"};